import React from 'react';

const DashboardPage: React.FC = () => {
  const stats = [
    { label: 'Total Leads', value: '127', color: '#3498db' },
    { label: 'Active Work Orders', value: '23', color: '#e74c3c' },
    { label: 'Total Clients', value: '89', color: '#2ecc71' },
    { label: 'Revenue This Month', value: '$42,150', color: '#f39c12' }
  ];

  const recentActivities = [
    { id: 1, type: 'lead', message: 'New lead: AC Installation at 123 Main St', time: '2 hours ago' },
    { id: 2, type: 'workorder', message: 'Completed: Furnace Repair for John Smith', time: '4 hours ago' },
    { id: 3, type: 'client', message: 'New client registered: ABC Corporation', time: '6 hours ago' },
    { id: 4, type: 'workorder', message: 'Scheduled: Heat Pump Maintenance for Tomorrow', time: '8 hours ago' },
    { id: 5, type: 'lead', message: 'Quote sent for Commercial HVAC System', time: '1 day ago' }
  ];

  const upcomingTasks = [
    { id: 1, task: 'AC Installation - 456 Oak Ave', priority: 'high', dueDate: 'Today, 2:00 PM' },
    { id: 2, task: 'Furnace Inspection - Downtown Office', priority: 'medium', dueDate: 'Tomorrow, 9:00 AM' },
    { id: 3, task: 'Follow up on pending quotes', priority: 'low', dueDate: 'This Week' },
    { id: 4, task: 'Team meeting - Monthly Review', priority: 'medium', dueDate: 'Friday, 10:00 AM' }
  ];

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high': return '#e74c3c';
      case 'medium': return '#f39c12';
      case 'low': return '#95a5a6';
      default: return '#95a5a6';
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '10px' }}>Dashboard</h1>
        <p style={{ color: '#6c757d' }}>Welcome back! Here's what's happening with your HVAC business.</p>
      </div>

      <div className="dashboard-stats">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ background: `linear-gradient(135deg, ${stat.color} 0%, ${stat.color}CC 100%)` }}>
            <div className="stat-number">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '30px' }}>
        <div className="card">
          <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>Recent Activity</h3>
          <div>
            {recentActivities.map((activity) => (
              <div key={activity.id} style={{ 
                padding: '15px 0', 
                borderBottom: '1px solid #f8f9fa',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
              }}>
                <div>
                  <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}>{activity.message}</p>
                  <small style={{ color: '#6c757d' }}>{activity.time}</small>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>Upcoming Tasks</h3>
          <div>
            {upcomingTasks.map((task) => (
              <div key={task.id} style={{ 
                padding: '15px 0', 
                borderBottom: '1px solid #f8f9fa',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div style={{ flex: 1 }}>
                  <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}>{task.task}</p>
                  <small style={{ color: '#6c757d' }}>{task.dueDate}</small>
                </div>
                <span 
                  className="status"
                  style={{ 
                    backgroundColor: `${getPriorityColor(task.priority)}20`,
                    color: getPriorityColor(task.priority)
                  }}
                >
                  {task.priority}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card">
        <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>Quick Actions</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <button className="btn btn-primary" style={{ padding: '15px' }}>
            📝 Create New Lead
          </button>
          <button className="btn btn-primary" style={{ padding: '15px' }}>
            🔧 New Work Order
          </button>
          <button className="btn btn-primary" style={{ padding: '15px' }}>
            👥 Add Client
          </button>
          <button className="btn btn-primary" style={{ padding: '15px' }}>
            📊 View Reports
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;